import React from 'react'
import styled from 'styled-components'

const About = styled.div`
    background: url(${props => props.image});
    height: 1400px;
    background-size: cover;
    background-position: center;
    position: relative;

    @media (max-width: 640px) {
        height: 1200px;
    }

    @media (max-width: 430px) {
        height: 1400px;
    }
`

const AboutGroup = styled.div`
    margin: 0 auto;
    max-width: 800px;
    padding: 100px 0;
    text-align: left;
    @media (max-width: 1000px) {
        text-align: center;
    }
`

const AboutTitle = styled.h1`
    margin: 0;
    color: white;
    font-size: 70px;
    font-weight: 800;
    line-height: 1.2;
    opacity: 0;
    animation: HeroAnimation;
    animation-duration: 3s;
    animation-delay: 0.1s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

    @media (max-width: 640px) {
        font-size: 40px;
    }
`

const AboutParagraph = styled.p`
    padding: 20px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 30px;
    font-weight: 600;
    line-height: 1.5;
    opacity: 0;
    animation: HeroAnimation;
    animation-duration: 3s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

    @media (max-width: 640px) {
        font-size: 24px;
    }
`

const AboutImage = styled.img`
  width: 200px;

  @media (max-width: 640px) {
    width: 140px;
  }
`

const JobsComponent = props => (
    <About image={props.image}>
        <AboutGroup>
            <AboutTitle>{props.title}</AboutTitle>
            <AboutParagraph>{props.intro}</AboutParagraph>
            <AboutParagraph>{props.skills}</AboutParagraph>
            <AboutParagraph>{props.end}</AboutParagraph>
        </AboutGroup>
    </About>
)

export default JobsComponent